/**
 * Facts about the business that appear in more than one place: the footer, the hidden business
 * data for Google (JSON-LD) and the Google rating line. Change them here, not in the components.
 * Source: CLICKS-DMP/10_WEBSITE/Facts-P6-P7.md (interview with Ashraf, 24/25 September 2026).
 */
export const SITE_URL = "https://clicksdmp.com";

export const BUSINESS = {
  name: "Clicks DMP - Design & Media Production",
  shortName: "Clicks DMP",
  url: SITE_URL,
  id: `${SITE_URL}/#organization`,
  founderId: `${SITE_URL}/#founder`,
  founder: "Ashraf AlSalaita",
  founderJobTitle: "Inhaber, Fotograf und Videograf",
  /** Only in the hidden data, never as a headline (Ashraf, 24 Sep 2026). */
  foundingDate: "2020",
  description:
    "Fotografie, Videoproduktion und Social-Media-Content aus Mannheim für Unternehmen in der Rhein-Neckar-Region.",
  telephone: "+49 176 70027200",
  telephoneDisplay: "+49 176 700 27 200",
  telephoneHref: "tel:+4917670027200",
  email: "info@clicksdmp.com",
  address: {
    street: "Karl-Traub-Straße 15",
    postalCode: "68199",
    city: "Mannheim",
    region: "Baden-Württemberg",
    country: "DE",
  },
  geo: { latitude: 49.46316, longitude: 8.48497 },
  openingHours: {
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    opens: "09:00",
    closes: "18:00",
  },
  openingHoursText: "Mo–Fr 09:00–18:00 Uhr · Termine nach Vereinbarung",
  areaServed: ["Mannheim", "Heidelberg", "Ludwigshafen", "Rhein-Neckar-Kreis"],
  knowsLanguage: ["de", "en", "ar"],
  priceRange: "€€",
  logo: `${SITE_URL}/logo.png`,
  image: `${SITE_URL}/og-image.jpg`,
  profiles: {
    instagram: "https://www.instagram.com/clicksdmp/",
    facebook: "https://www.facebook.com/clicksdmp",
    tiktok: "https://www.tiktok.com/@clicksdmp",
    linkedin: "https://www.linkedin.com/company/clicksdmp",
    google: "https://maps.google.com/?cid=16447947573775882498",
  },
  /** Snapshot of the public Google rating. Refresh the three values whenever the numbers change. */
  googleRating: { value: "5,0", count: 6, asOf: "September 2026" },
} as const;

export const SAME_AS: string[] = Object.values(BUSINESS.profiles);
